module.exports = __webpack_public_path__ + "img/help_1.f9a7fa7b.png";